import { useRequiredContext } from "@redotech/react-util/context";
import { LoadState, useLoad } from "@redotech/react-util/load";
import { ShopifyProduct } from "@redotech/shopify-client/ajax";
import { useState } from "react";
import { RedoShopifyRpcClientContext } from "../client/redo-shopify-rpc-client";
import {
  ExtensionShopifyClientContext,
  shopifyProductHandle,
} from "../shopify";

export function useConciergeQuestions({
  currentUrl,
}: {
  currentUrl: URL;
}): LoadState<{ questions: string[] }> {
  const rpcClient = useRequiredContext(RedoShopifyRpcClientContext);
  const extensionShopifyClient = useRequiredContext(
    ExtensionShopifyClientContext,
  );

  const [product, setProduct] = useState<ShopifyProduct | undefined>(undefined);

  const productHandle = shopifyProductHandle(currentUrl.href);

  const questionsLoad = useLoad(async () => {
    const product = await getProduct();
    const result = await rpcClient.getProductQuestions({
      productId: product.id.toString(),
    });
    return result;
  }, []);

  const getProduct = async () => {
    if (product) {
      return product;
    }

    const productResult =
      await extensionShopifyClient.productGet(productHandle);
    setProduct(productResult);
    return productResult;
  };

  return questionsLoad;
}
